import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 20.002px;
  height: 19.989px;
  margin-right: 0.5rem;
  position: absolute;
  top: 10px;
  left: 10px;
`;

const TreeSearchIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <path
        data-name="Search icon"
        d="M19.66 17.999l-4.226-4.223a8.622 8.622 0 1 0-1.647 1.645l4.227 4.224a1.164 1.164 0 1 0 1.646-1.646zM2.328 8.587a6.267 6.267 0 1 1 6.267 6.262A6.272 6.272 0 0 1 2.329 8.59z"
        fill="#aaa"
      />
    </Svg>
  );
};

export default TreeSearchIcon;
